<script setup lang="ts">
	import {InertiaLinkProps, Link as InertiaLink} from '@inertiajs/vue3';

	defineProps<InertiaLinkProps>();
</script>

<template>
	<InertiaLink v-bind="{...$props, ...$attrs}">
		<slot />
	</InertiaLink>
</template>
